"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutGrid = exports.LayoutGridItem = void 0;
const react_1 = __importStar(require("react"));
const sds_1 = require("@squiz/sds");
/**
 * This has been setup as a way to patch React FC design into the class driven methodology of the SDS.
 *
 * This child FC exists only for the LayoutGrid FC to deconstruct its children
 * and pass them in as how the SDS wants them as an array of items rather than
 * as child items as it normal in React.
 */
const LayoutGridItem = (props) => {
    return react_1.default.createElement("div", null);
};
exports.LayoutGridItem = LayoutGridItem;
const LayoutGrid = (props) => {
    const { children } = props;
    const gridItems = (0, react_1.useMemo)(() => {
        const visibleItems = [];
        react_1.default.Children.forEach(children, (element) => {
            if (!react_1.default.isValidElement(element) || element.type !== exports.LayoutGridItem)
                return;
            const { isVisible, children, ...rest } = element.props;
            if (isVisible) {
                visibleItems.push({ ...rest, isVisible, component: children, key: element.key });
            }
        });
        return visibleItems;
    }, [children]);
    return react_1.default.createElement(sds_1.Grid, { ...props, items: gridItems });
};
exports.LayoutGrid = LayoutGrid;
